/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProjectSort,
    ProjectSortFromJSON,
    ProjectSortFromJSONTyped,
    ProjectSortToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchProjectRequest
 */
export interface SearchProjectRequest {
    /**
     * 
     * @type {number}
     * @memberof SearchProjectRequest
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchProjectRequest
     */
    pageSize?: number;
    /**
     * 
     * @type {ProjectSort}
     * @memberof SearchProjectRequest
     */
    sortMode?: ProjectSort;
    /**
     * 
     * @type {string}
     * @memberof SearchProjectRequest
     */
    searchQuery?: string | null;
}

export function SearchProjectRequestFromJSON(json: any): SearchProjectRequest {
    return SearchProjectRequestFromJSONTyped(json, false);
}

export function SearchProjectRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchProjectRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'sortMode': !exists(json, 'sortMode') ? undefined : ProjectSortFromJSON(json['sortMode']),
        'searchQuery': !exists(json, 'searchQuery') ? undefined : json['searchQuery'],
    };
}

export function SearchProjectRequestToJSON(value?: SearchProjectRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'sortMode': ProjectSortToJSON(value.sortMode),
        'searchQuery': value.searchQuery,
    };
}


